import { render, staticRenderFns } from "./179.vue?vue&type=template&id=35852988&scoped=true&"
var script = {}
import style0 from "./179.vue?vue&type=style&index=0&id=35852988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35852988",
  null
  
)

export default component.exports